<div class="d-flex card">
	<div class="d-flex">
		<div class="display-6 ms-1 mt-2 mb-1">Links</div>
		<div class="ms-auto">
			<app-record-control-footer
				[hideAdd]="false"
				[hideCancel]="true"
				[hideDelete]="true"
				[hideSave]="true"
				(onAddChange)="onAdd()"
			></app-record-control-footer>
		</div>
	</div>
	<p-divider></p-divider>

	<p-table
		#dt
		styleClass="p-datatable-responsive-demo"
		[value]="linkList"
		[loading]="!linkList"
		[globalFilterFields]="app.keys(linkList)"
		dataKey="id"
		[scrollable]="true"
		[rows]="100"
		scrollHeight="700px"
		[virtualScroll]="true"
		[virtualRowHeight]="40"
	>
		<ng-template pTemplate="caption">
			<div class="table-header d-flex">
				<div class="flex-grow-1">
					<span class="p-float-label p-input-icon-left m-2 w-100">
						<i class="pi pi-search"></i>
						<input
							pInputText
							class="w-100"
							id="globalSearch"
							name="globalSearch"
							style="width: 100%"
							type="text"
							(input)="dt.filterGlobal($event.target.value, 'contains')"
						/>
						<label for="globalSearch">Search...</label>
					</span>
				</div>
				<div class="ms-2">
					<p-button pRipple styleClass="p-button-raised p-button-secondary m-2" (click)="downloadFile(linkList)">
						<ng-template pTemplate="content">
							<div class="d-flex justify-content-center">
								<fa-icon [icon]="['far', 'download']" size="lg" class="ms-1 me-2"></fa-icon>
								Export
							</div>
						</ng-template>
					</p-button>
					<p-button pRipple styleClass="p-button-raised p-button-secondary m-2" (click)="printableList()">
						<ng-template pTemplate="content">
							<div class="d-flex justify-content-center">
								<fa-icon [icon]="['far', 'print']" size="lg" class="ms-1 me-2"></fa-icon>
								Printable
							</div>
						</ng-template>
					</p-button>
				</div>
			</div>
		</ng-template>
		<ng-template pTemplate="header">
			<tr>
				<th pSortableColumn="id">Table ID</th>
				<th>Menu</th>
				<th>Order Type</th>
				<th>URL</th>
				<th></th>
			</tr>
		</ng-template>
		<ng-template let-rec let-idx="rowIndex" pTemplate="body">
			<tr>
				<td>{{ rec.id }}</td>
				<td>
					<p-dropdown
						[options]="venueService.ooMenus"
						[(ngModel)]="rec.menuKey"
						optionLabel="name"
						optionValue="key"
						[autoDisplayFirst]="false"
						showClear="true"
						(onChange)="venueService.ooLinkSave(rec)"
						[style]="{ width: '100%' }"
					>
					</p-dropdown>
				</td>
				<td>
					<p-dropdown
						[options]="venueService.ooOrderTypes"
						[(ngModel)]="rec.orderType"
						optionLabel="displayName"
						optionValue="key"
						[autoDisplayFirst]="false"
						showClear="true"
						(onChange)="venueService.ooLinkSave(rec)"
						[style]="{ width: '100%' }"
					>
					</p-dropdown>
				</td>
				<td>
					<a target=" _blank" href="{{ baseUrl }}/{{ venueService.venueKey }}?linkKey={{ rec.key }}">URL</a>
				</td>
				<td class="d-flex">
					<div class="ms-auto">
						<app-record-control-footer
							[hideAdd]="true"
							[hideCancel]="true"
							[hideDelete]="false"
							[hideSave]="true"
							(onDeleteChange)="linkDelete(idx)"
						></app-record-control-footer>
					</div>
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<p-dialog *ngIf="bulkAdd" [(visible)]="bulkAdd" [breakpoints]="{ '960px': '75vw', '640px': '100vw' }" [style]="{ width: '50vw', height: '70vh' }">
	<ng-template pTemplate="header">
		<div class="w-100">
			<div class="d-flex">
				<fa-icon [icon]="['far', 'link']" class="me-4" size="2x"></fa-icon>
				<div class="display-8 ms-1 my-auto">Add Links</div>
			</div>
			<p-divider></p-divider>
		</div>
	</ng-template>
	<p-tabView>
		<p-tabPanel headerStyleClass="p-tab-header" styleClass="h-100">
			<ng-template pTemplate="header">
				<fa-icon [icon]="['far', 'bucket']" size="lg" class="ms-1"></fa-icon>
				<div class="mx-2">Bulk Create</div>
			</ng-template>
			<span class="p-float-label mt-4">
				<input type="text" class="w-100" id="prefix" pInputText ngModel #linkPrefix="ngModel" />
				<label for="prefix">Prefix</label>
			</span>
			<span class="p-float-label mt-4">
				<input pInputText id="startingId" ngModel #linkStart="ngModel" type="number" class="w-100" />
				<label for="startId">Starting Number</label>
			</span>
			<span class="p-float-label mt-4">
				<input pInputText id="endingId" ngModel #linkEnd="ngModel" type="number" class="w-100" />
				<label for="startId">Ending Number</label>
			</span>
			<div class="d-flex justify-center">
				<span *ngIf="linkStart.value && linkEnd.value && linkStart.value > linkEnd.value" style="color: red"
					>Ending number must be greater than starting number</span
				>
			</div>

			<div class="mt-4">
				<p-dropdown
					placeholder="Custom Menu..."
					[options]="venueService.ooMenus"
					optionLabel="name"
					optionValue="key"
					ngModel
					#linkMenuKey="ngModel"
					name="customMenuList"
					[style]="{ width: '100%' }"
					appendTo="body"
				>
				</p-dropdown>
			</div>
			<div class="mt-4">
				<p-dropdown
					placeholder="Order Type..."
					[options]="venueService.ooOrderTypes"
					optionLabel="displayName"
					ngModel
					#linkOrderTypeKey="ngModel"
					optionValue="key"
					name="orderTypes"
					[style]="{ width: '100%' }"
					appendTo="body"
				></p-dropdown>
			</div>

			<ng-template pTemplate="footer">
				<app-record-control-footer
					[hideAdd]="true"
					[hideCancel]=""
					[hideDelete]="true"
					[hideSave]=""
					(onCancelChange)="bulkAdd = false; linkSelected = undefined"
					(onSaveChange)="linkAddBulk(linkStart.value, linkEnd.value, linkPrefix.value, linkMenuKey.value, linkOrderTypeKey.value); dVisible = false"
					[saveDisabled]="linkStart.value > linkEnd.value || linkStart.value == 0 || linkStart.value == 0"
				></app-record-control-footer>
			</ng-template>
		</p-tabPanel>
		<p-tabPanel headerStyleClass="p-tab-header" styleClass="h-100">
			<ng-template pTemplate="header">
				<fa-icon [icon]="['far', 'circle-1']" size="lg" class="ms-1"></fa-icon>
				<div class="mx-2">Single Link</div>
			</ng-template>
			<div class="mt-4">
				<span class="p-float-label">
					<input type="text" pInputText id="linkId" [(ngModel)]="linkSelected.id" class="w-100" />
					<label for="linkId">Table Number / ID</label>
				</span>
			</div>
			<div class="mt-4">
				<p-dropdown
					placeholder="Custom Menu..."
					[options]="venueService.ooMenus"
					optionLabel="name"
					optionValue="key"
					name="customMenuList"
					[(ngModel)]="linkSelected.menuKey"
					[style]="{ width: '100%' }"
					appendTo="body"
				>
				</p-dropdown>
			</div>
			<div class="mt-4">
				<p-dropdown
					placeholder="Order Type..."
					[options]="venueService.ooOrderTypes"
					optionLabel="displayName"
					optionValue="key"
					name="orderTypes"
					[(ngModel)]="linkSelected.orderType"
					[style]="{ width: '100%' }"
					appendTo="body"
				>
				</p-dropdown>
			</div>

			<ng-template pTemplate="footer">
				<app-record-control-footer
					[hideAdd]="true"
					[hideCancel]=""
					[hideDelete]="true"
					[hideSave]=""
					(onCancelChange)="bulkAdd = false; linkSelected = undefined"
					(onSaveChange)="linkAdd(linkSelected); linkSelected = undefined"
					[cancelDisabled]=""
					[deleteDisabled]=""
					[saveDisabled]="!linkSelected.id || !linkSelected.menuKey || !linkSelected.orderType"
				></app-record-control-footer>
			</ng-template>
		</p-tabPanel>
	</p-tabView>
</p-dialog>

<app-link-qr-export *ngIf="showPrintable" [(showPrintable)]="showPrintable" [(linkList)]="linkList"></app-link-qr-export>
